export default __webpack_public_path__ + "static/media/ic_ftm_16.1826878d.svg";